import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { IFeedbackFields } from 'types/interfaces/feedback.interfaces';

export const FeedbackApi = {
    sendFeedbackForm: (data: IFeedbackFields): Promise<AxiosResponse<IFeedbackFields>> =>
        axiosInstance.post<IFeedbackFields>('explore/contact-us', data),
};
